import PropTypes from 'prop-types'
import Precios from '../precios/Precios'
import styles from './Pedido.module.css'

const EnvioItem = ({ costoEnvio }) => {
  return (
    <div className={styles.pedidoItem}>
      <div className={styles.envioItemCabecera}>
        <span className={styles.envioItemLabel}>Envío</span>
        <Precios
          precio={costoEnvio}
          monedaSimbolo={'$'}
          alicuota={21}
          showSinIVA={true}
        />
      </div>
    </div>
  )
}

EnvioItem.propTypes = {
  costoEnvio: PropTypes.number.isRequired
}

export default EnvioItem
